import { jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { ImpersonationBanner } from "./styles/ImpersonationBanner.mjs";
import { AuthN, getConfig } from "@seek/online-identity";
const getAuthN = () => new AuthN(getConfig("seekAnz-candidate", window.location));
const getContextFromIdToken = async () => {
  if (window.location.protocol === "http:") {
    return Promise.resolve(null);
  }
  try {
    const client = getAuthN();
    const identity = await client.getIdentity();
    if (!identity || !identity.act) {
      return null;
    }
    const user = await client.getUser();
    const showCustomerServiceView = user["http://seek/claims/customer_service_view"] === true;
    return {
      actor: {
        email: identity.act.email
      },
      subject: {
        email: identity.sub.email
      },
      showCustomerServiceView
    };
  } catch (err) {
    return null;
  }
};
const Container = ({
  context: initialContext = null,
  additionalInfo,
  useAuthN = true
}) => {
  const [context, setContext] = useState(
    initialContext
  );
  useEffect(() => {
    if (useAuthN && context === null) {
      getContextFromIdToken().then(setContext);
    }
  }, [context, useAuthN]);
  if (!context) {
    return null;
  }
  return /* @__PURE__ */ jsx(ImpersonationBanner, { context, additionalInfo });
};
export {
  Container as ImpersonationBanner
};
